/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__deleted_number__ } from '../models/ControllerResponse__deleted_number__';
import type { ControllerResponse_PipelineHealthDailyStatistic_Array_ } from '../models/ControllerResponse_PipelineHealthDailyStatistic_Array_';
import type { ControllerResponse_PipelineHealthOperatorCoverageReport_ } from '../models/ControllerResponse_PipelineHealthOperatorCoverageReport_';
import type { ControllerResponse_PipelineHealthOperatorProperty_Array_ } from '../models/ControllerResponse_PipelineHealthOperatorProperty_Array_';
import type { ControllerResponse_PipelineHealthOrganizationBuildingsResponse_ } from '../models/ControllerResponse_PipelineHealthOrganizationBuildingsResponse_';
import type { ControllerResponse_PipelineHealthOrganizationBuildingTrends_ } from '../models/ControllerResponse_PipelineHealthOrganizationBuildingTrends_';
import type { ControllerResponse_PipelineHealthReportFees_ } from '../models/ControllerResponse_PipelineHealthReportFees_';
import type { ControllerResponse_PipelineHealthSourceCompletion_Array_ } from '../models/ControllerResponse_PipelineHealthSourceCompletion_Array_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PipelineHealthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param selectedDate Calendar date the scraper stats are read for (YYYY-MM-DD).
     * @returns ControllerResponse_PipelineHealthDailyStatistic_Array_ Ok
     * @throws ApiError
     */
    public list(
        selectedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthDailyStatistic_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health',
            query: {
                'selected_date': selectedDate,
            },
        });
    }
    /**
     * @param scrapedDate Calendar date of organization building scrapes (YYYY-MM-DD).
     * @returns ControllerResponse_PipelineHealthOrganizationBuildingsResponse_ Ok
     * @throws ApiError
     */
    public listOrganizationBuildings(
        scrapedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthOrganizationBuildingsResponse_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/organization_buildings',
            query: {
                'scraped_date': scrapedDate,
            },
        });
    }
    /**
     * @param selectedDate Inclusive end date (YYYY-MM-DD). Returns the last 30 days ending on that date.
     * @returns ControllerResponse_PipelineHealthOrganizationBuildingTrends_ Ok
     * @throws ApiError
     */
    public listOrganizationBuildingsTrends(
        selectedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthOrganizationBuildingTrends_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/organization_buildings/trends',
            query: {
                'selected_date': selectedDate,
            },
        });
    }
    /**
     * @param selectedDate Calendar date the pipeline counts are read for (YYYY-MM-DD).
     * @returns ControllerResponse_PipelineHealthOperatorCoverageReport_ Ok
     * @throws ApiError
     */
    public getOperatorCoverage(
        selectedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthOperatorCoverageReport_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/operator_coverage',
            query: {
                'selected_date': selectedDate,
            },
        });
    }
    /**
     * @param organizationId Operator whose properties are listed.
     * @param selectedDate Calendar date the pipeline fields are read for (YYYY-MM-DD).
     * @returns ControllerResponse_PipelineHealthOperatorProperty_Array_ Ok
     * @throws ApiError
     */
    public listOperatorProperties(
        organizationId: number,
        selectedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthOperatorProperty_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/operator_coverage/{organization_id}/properties',
            path: {
                'organization_id': organizationId,
            },
            query: {
                'selected_date': selectedDate,
            },
        });
    }
    /**
     * Fee coverage over report buildings (subjects and comps on active reports) for the date.
     * @param selectedDate Calendar date (YYYY-MM-DD).
     * @returns ControllerResponse_PipelineHealthReportFees_ Ok
     * @throws ApiError
     */
    public getReportFees(
        selectedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthReportFees_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/report_fees',
            query: {
                'selected_date': selectedDate,
            },
        });
    }
    /**
     * Per source and field: fill rate on the selected date against the source's own recent baseline.
     * @param selectedDate Calendar date to evaluate (YYYY-MM-DD).
     * @returns ControllerResponse_PipelineHealthSourceCompletion_Array_ Ok
     * @throws ApiError
     */
    public listFieldCompletion(
        selectedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthSourceCompletion_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/field_completion',
            query: {
                'selected_date': selectedDate,
            },
        });
    }
    /**
     * @returns ControllerResponse__deleted_number__ Ok
     * @throws ApiError
     */
    public invalidateCache(): CancelablePromise<ControllerResponse__deleted_number__> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/pipeline_health/cache',
        });
    }
}
